module.exports = __webpack_public_path__ + "static/media/Eye.085faf9b.svg";